import React from "react";
import Foot from "./Foot";
import Navigation from "./Navigation";
import Trailer from "./Trailer";
import MovieCard from "./MovieCard";
import Breaker from "./Breaker";
import SEO from "./SEO";
import Clipboard from "react-clipboard.js";
const { createSlug } = require("../libraries/Interiors");

const config = require("../config");

class Details extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            movie: "",
            trailerVisible: false,
            timestamp: 0
        };
    }

    componentDidMount() {
        const { movieid } = this.props.match.params;
        this.fetchFromTMDB(movieid.split("-")[0]);
        this.getTimeStamp();
    }

    componentDidUpdate() {
        const { titleChange } = this.props;
        titleChange(
            `${this.state.movie.title} ${
                this.state.movie.release_date
                    ? "(" + this.state.movie.release_date.split("-")[0] + ")"
                    : ""
            }` || "Title Unavailable!"
        );
        // changeMetaData(this.state.movie);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.movieid !== this.state.movie.id) {
            this.fetchFromTMDB(nextProps.match.params.movieid);

            const ifWatched = nextProps.watched.find(
                tofind => tofind.id === this.state.movie.id
            );

            if (ifWatched) {
                this.setState(state => ({
                    ...state,
                    ...{ watched: ifWatched }
                }));
                this.getTimeStamp();
            }
        }
    }

    fetchFromTMDB = movieid => {
        this.APICallEndpoint = `${config.niceAPI.replace("__ID", movieid)}`;

        fetch(this.APICallEndpoint)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    movie: { ...data }
                });
            });
    };

    getTimeStamp = ({ watched } = this.props) => {
        const watchedHandling = watched.filter(
            watchedMovies => watchedMovies.id === this.state.movie.id
        );
        if (watchedHandling && watchedHandling.length > 0) {
            this.setState(state => ({
                ...state,
                ...{ timestamp: watchedHandling[0].timestamp }
            }));
        }
    };

    onTrailerDisplay = () => {
        this.setState(state => ({
            ...state,
            trailerVisible: !this.state.trailerVisible
        }));
    };

    onSuccess = () => {
        console.info("Sucessfully copied " + this.state.movie.title);
    };

    getText = () => {
        return `${config.siteURL}/details/${this.state.movie.id}-${createSlug(
            this.state.movie.title
        )}`;
    };

    render() {
        const {
            onSearch,
            totalFavorites,
            favoriteCallback,
            updateFavorites,
            watchedToggle,
            favorites,
            totalWatched
        } = this.props;

        return (
            <div>
                <Navigation
                    onSearch={onSearch}
                    totalFavorites={totalFavorites}
                    totalWatched={totalWatched}
                />
                <div className="container">
                    {this.state.movie ? (
                        <SEO generateFrom={this.state.movie} />
                    ) : (
                        ""
                    )}
                    {this.state.movie &&
                    this.state.movie.videos &&
                    this.state.movie.videos.results.length > 0 &&
                    this.state.movie.videos.results ? (
                        <Trailer
                            trailerLink={`${
                                this.state.movie.videos.results &&
                                this.state.movie.videos.results.find(
                                    videos =>
                                        videos.type.toLowerCase() === "trailer"
                                ) &&
                                this.state.movie.videos.results.find(
                                    videos =>
                                        videos.type.toLowerCase() === "trailer"
                                ).key
                                    ? this.state.movie.videos.results.find(
                                          videos =>
                                              videos.type.toLowerCase() ===
                                              "trailer"
                                      ).key
                                    : "No Trailer available!"
                            }`}
                            title={
                                this.state.movie.videos.results.find(
                                    videos =>
                                        videos.type.toLowerCase() === "trailer"
                                ) &&
                                this.state.movie.videos.results
                                    .find(
                                        videos =>
                                            videos.type.toLowerCase() ===
                                            "trailer"
                                    )
                                    .hasOwnProperty("name")
                                    ? this.state.movie.videos.results.find(
                                          videos =>
                                              videos.type.toLowerCase() ===
                                              "trailer"
                                      ).name
                                    : "No Trailer available!"
                            }
                            visible={this.state.trailerVisible}
                            onClick={this.onTrailerDisplay}
                            trailerWindowEvent={this.onTrailerDisplay}
                        />
                    ) : (
                        ""
                    )}
                    {this.state.movie ? (
                        <div
                            className="details-page"
                            itemScope
                            itemType="http://schema.org/Movie"
                        >
                            <div
                                className="background"
                                style={{
                                    backgroundImage: `url(${
                                        this.state.movie.backdrop_path
                                            ? config.tmdbAPIBackdropLink.replace(
                                                  "BACKDROP_LINK",
                                                  this.state.movie.backdrop_path
                                              )
                                            : config.brokenImages.backdrop
                                    })`
                                }}
                            />
                            <div className="details-container">
                                <div
                                    className="poster"
                                    itemScope
                                    itemType="http://schema.org/CreativeWork"
                                >
                                    <img
                                        src={
                                            this.state.movie.poster_path
                                                ? config.tmdbAPIPosterLink.replace(
                                                      "POSTER_LINK",
                                                      this.state.movie
                                                          .poster_path
                                                  )
                                                : config.brokenImages.poster
                                        }
                                        alt={this.state.movie.title}
                                        itemProp="thumbnailUrl"
                                    />
                                    <h3
                                        style={{
                                            display: "flex"
                                        }}
                                    >
                                        <b className="tag language">
                                            {this.state.movie
                                                .original_language &&
                                                this.state.movie.original_language.toUpperCase()}
                                        </b>
                                        <span
                                            className={
                                                this.state.movie.status &&
                                                this.state.movie.status ===
                                                    "Released"
                                                    ? "tag released"
                                                    : "tag unreleased"
                                            }
                                        >
                                            <span
                                                className="icon-calendar"
                                                style={{
                                                    verticalAlign: "middle",
                                                    margin: "0 8px 0 0"
                                                }}
                                            />
                                            {`${this.state.movie.release_date}`}
                                        </span>
                                        {this.state.movie &&
                                        this.state.movie.homepage &&
                                        this.state.movie.homepage ? (
                                            <a
                                                className="tag homepage"
                                                href={this.state.movie.homepage}
                                                title={`Go to ${
                                                    this.state.movie.title
                                                }'s homepage`}
                                            >
                                                <span className="icon-earth" />
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                        {this.state.movie &&
                                        this.state.movie.videos &&
                                        this.state.movie.videos.results.length >
                                            0 &&
                                        this.state.movie.videos.results ? (
                                            <a
                                                className="tag -trailer"
                                                onClick={this.onTrailerDisplay}
                                                title={`View ${
                                                    this.state.movie.title
                                                }'s Trailer!`}
                                                itemProp="trailer"
                                            >
                                                <span className="icon-film" />
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </h3>
                                </div>
                                <div className="details">
                                    <h1 className="title" itemProp="name">
                                        {`${this.state.movie.title}`}
                                        {this.state.movie.runtime ? (
                                            <span className="spanned">
                                                <span className="icon-clock2" />
                                                <span className="txt">
                                                    {`${
                                                        this.state.movie.runtime
                                                    } min`}
                                                </span>
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {
                                            <Clipboard
                                                option-text={this.getText}
                                                onSuccess={this.onSuccess}
                                                title="Copy share URL to clipboard .."
                                                style={{
                                                    verticalAlign: "middle"
                                                }}
                                            >
                                                <span
                                                    className="icon-content_paste"
                                                    title="Copy share URL to clipboard .."
                                                />
                                            </Clipboard>
                                        }
                                    </h1>
                                    {this.state.movie &&
                                    this.state.movie.tagline &&
                                    this.state.movie.tagline.length > 0 ? (
                                        <h2 className="tagLine">
                                            {this.state.movie.tagline}
                                        </h2>
                                    ) : (
                                        ""
                                    )}
                                    <p
                                        className="description"
                                        itemProp="description"
                                    >
                                        {`${this.state.movie.overview}`}
                                    </p>
                                    <span className="genres">
                                        {this.state.movie.genres &&
                                            this.state.movie.genres.map(
                                                genre => (
                                                    <span
                                                        className="genre"
                                                        key={`genre-${
                                                            genre.name
                                                        }-${genre.id}`}
                                                    >
                                                        <span
                                                            itemProp="genre"
                                                            className="icon-price-tag"
                                                            style={{
                                                                verticalAlign:
                                                                    "middle",
                                                                fontSize:
                                                                    "11px",
                                                                margin:
                                                                    "0 8px 0 0"
                                                            }}
                                                        />
                                                        {genre.name}
                                                    </span>
                                                )
                                            )}
                                    </span>
                                    {/* Ratings */}
                                    {this.state.movie &&
                                    this.state.movie.vote_average &&
                                    this.state.movie.imdb_id ? (
                                        <span
                                            className="monetary-container"
                                            style={{
                                                margin: "0 0 2% 0"
                                            }}
                                        >
                                            <a
                                                href={`https://www.imdb.com/title/${
                                                    this.state.movie.imdb_id
                                                }/`}
                                                title={`IMDB ID : ${
                                                    this.state.movie.imdb_id
                                                }`}
                                                style={{
                                                    textDecoration: "none",
                                                    color: "#6d7886"
                                                }}
                                                itemProp="aggregateRating"
                                                itemScope
                                                itemType="http://schema.org/AggregateRating"
                                            >
                                                <span
                                                    className="budget"
                                                    title={`IMDB Rating : ${
                                                        this.state.movie
                                                            .vote_average
                                                    }/10`}
                                                >
                                                    <span
                                                        className="icon-imdb"
                                                        style={{
                                                            color:
                                                                "rgb(241, 198, 31)"
                                                        }}
                                                        itemProp="ratingValue"
                                                    />&nbsp;
                                                    {`${
                                                        this.state.movie
                                                            .vote_average
                                                    }/10`}
                                                </span>
                                            </a>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                    {/* Budgets & Stuff */}
                                    {this.state.movie &&
                                    this.state.movie.budget &&
                                    this.state.movie.budget > 0 ? (
                                        <span className="monetary-container">
                                            <span
                                                className="budget"
                                                title="Budget"
                                            >
                                                <span className="icon-wallet" />
                                                {`$${this.state.movie.budget.toLocaleString()}`}
                                            </span>
                                            <span
                                                className="revenue"
                                                title="Revenue"
                                            >
                                                <span className="icon-dollar" />
                                                {`$${this.state.movie.revenue.toLocaleString()}`}
                                            </span>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                    <span className="togglingContainer">
                                        {/* Add to Favorites & Collection? */}
                                        {this.state.movie.id &&
                                        this.props.favorites &&
                                        this.props.favorites.some(
                                            favMovie =>
                                                favMovie.id ===
                                                this.state.movie.id
                                        ) ? (
                                            <span
                                                className="tag solarized-darkgray"
                                                title={`Remove ${
                                                    this.state.movie.title
                                                } from favorites.`}
                                                onClick={() =>
                                                    favoriteCallback(
                                                        this.state.movie
                                                    )
                                                }
                                                style={{
                                                    margin: "2% 5px 0px 0.5%"
                                                }}
                                            >
                                                - Remove from Favorites.
                                            </span>
                                        ) : (
                                            <span
                                                className="tag solarized-lemonred"
                                                title={`Add ${
                                                    this.state.movie.title
                                                } to favorites.`}
                                                onClick={() =>
                                                    favoriteCallback(
                                                        this.state.movie
                                                    )
                                                }
                                                style={{
                                                    margin: "2% 5px 0px 0.5%"
                                                }}
                                            >
                                                + Add to Favorites.
                                            </span>
                                        )}

                                        {/* If already watched! */}
                                        {this.state.movie.id &&
                                        this.props.watched &&
                                        this.props.watched.some(
                                            watchedMovies =>
                                                watchedMovies.id ===
                                                this.state.movie.id
                                        ) ? (
                                            <span
                                                className="tag solarized-darkgray"
                                                title={`You watched this movie on ${
                                                    this.props.watched.find(
                                                        watchedMovies =>
                                                            watchedMovies.id ===
                                                            this.state.movie.id
                                                    ).timestamp
                                                }`}
                                                style={{
                                                    margin: "2% 5px 0px 0.5%"
                                                }}
                                                onClick={() =>
                                                    watchedToggle(
                                                        this.state.movie
                                                    )
                                                }
                                            >
                                                <span
                                                    className={`icon-eye${
                                                        this.props.watched.some(
                                                            watchedMovies =>
                                                                watchedMovies.id ===
                                                                this.state.movie
                                                                    .id
                                                        )
                                                            ? ""
                                                            : "-blocked"
                                                    }`}
                                                />&nbsp;{`Watched on ${
                                                    this.props.watched.find(
                                                        watchedMovies =>
                                                            watchedMovies.id ===
                                                            this.state.movie.id
                                                    ).timestamp
                                                }.`}
                                            </span>
                                        ) : (
                                            <span
                                                className="tag solarized-darkgray"
                                                title={`Mark this movie as watched.`}
                                                style={{
                                                    margin: "2% 5px 0px 0.5%"
                                                }}
                                                onClick={() =>
                                                    watchedToggle(
                                                        this.state.movie
                                                    )
                                                }
                                            >
                                                <span
                                                    className={`icon-eye${
                                                        this.props.watched.some(
                                                            watchedMovies =>
                                                                watchedMovies.id ===
                                                                this.state.movie
                                                                    .id
                                                        )
                                                            ? ""
                                                            : "-blocked"
                                                    }`}
                                                />&nbsp;{`Unwatched`}
                                            </span>
                                        )}
                                    </span>

                                    {/* Credit Section */}
                                    <Breaker
                                        title="Casts & Crews"
                                        hidden={
                                            this.state.movie &&
                                            this.state.movie.credits &&
                                            this.state.movie.credits.cast
                                                ? false
                                                : true
                                        }
                                    />
                                    {this.state.movie &&
                                    this.state.movie.credits &&
                                    this.state.movie.credits.cast ? (
                                        <span className="credits">
                                            {this.state.movie.credits.cast
                                                .slice(0, 7)
                                                .map(cast => (
                                                    <div
                                                        key={`credits-${
                                                            cast.name
                                                        }`}
                                                        className="cast"
                                                        itemProp="actor"
                                                        itemScope
                                                        itemType="http://schema.org/Person"
                                                    >
                                                        <span
                                                            className="poster"
                                                            style={{
                                                                backgroundImage: `url(${config.tmdbAPIStillImagesLink.replace(
                                                                    "STILL_IMAGE",
                                                                    cast.profile_path
                                                                )})`
                                                            }}
                                                        />
                                                        <span itemProp="name">
                                                            {cast.name}
                                                        </span>
                                                    </div>
                                                ))}
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                    <Breaker
                                        title="Producers"
                                        hidden={
                                            this.state.movie &&
                                            this.state.movie
                                                .production_companies &&
                                            this.state.movie
                                                .production_companies.length > 0
                                                ? false
                                                : true
                                        }
                                    />
                                    <span
                                        className="producers"
                                        itemProp="productionCompany"
                                        itemScope
                                        itemType="http://schema.org/Organization"
                                    >
                                        {this.state.movie &&
                                        this.state.movie.production_companies &&
                                        this.state.movie.production_companies
                                            .length > 0
                                            ? this.state.movie.production_companies
                                                  .filter(
                                                      company =>
                                                          company.logo_path &&
                                                          company.logo_path
                                                              .length > 0
                                                  )
                                                  .map(company => (
                                                      <span
                                                          key={`company-${
                                                              company.name
                                                          }`}
                                                          title={company.name}
                                                          itemProp="name"
                                                      >
                                                          <img
                                                              src={`${config.tmdbAPIStillImagesLink.replace(
                                                                  "STILL_IMAGE",
                                                                  company.logo_path
                                                              )}`}
                                                              alt={company.name}
                                                          />
                                                      </span>
                                                  ))
                                            : ""}
                                    </span>
                                    {/* Similar Movies */}
                                    <Breaker
                                        title="Similar Movies"
                                        hidden={
                                            this.state.movie &&
                                            this.state.movie.similar &&
                                            this.state.movie.similar.results
                                                .length > 0
                                                ? false
                                                : true
                                        }
                                    />
                                    <ul className="movies">
                                        {this.state.movie &&
                                            this.state.movie.similar &&
                                            this.state.movie.similar.results
                                                .slice(0, 4)
                                                .map(similarMovie => (
                                                    <MovieCard
                                                        movie={similarMovie}
                                                        key={similarMovie.id}
                                                        toggleFavorite={
                                                            updateFavorites
                                                        }
                                                        favorites={favorites}
                                                    />
                                                ))}
                                    </ul>
                                </div>
                            </div>
                            <Foot />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        );
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/components/Details.js